import { createSelector } from 'reselect'

const getLinkState = state => state.MagicLinks.linkState
const getLink = state => state.MagicLinks.link

const getLinkId = createSelector([getLink], link => (link ? link.id : null))

const getTypeOfError = createSelector([getLinkState], linkState => {
  if (!linkState.error) return null
  switch (linkState.error.data.errors[0].err) {
    case 'e0000':
      return 'error_invalid_token'
    default:
      return 'error_unknown'
  }
})

const getErrorRef = createSelector(
  [getLinkState],
  linkState => (!linkState.error ? null : linkState.error.data.errors[0].err)
)

const getActionRedirect = createSelector(
  [getLink, getLinkState],
  (link, linkState) =>
    !linkState.actionDone ? null : link.actions[linkState.actionDone].redirect
)

const isLinkResent = createSelector(
  [getLinkState],
  linkState => linkState.linkResent
)

const getSendAnotherRequest = state => state.MagicLinks.sendAnotherRequest

export {
  getTypeOfError,
  getActionRedirect,
  getLink,
  getLinkId,
  getErrorRef,
  isLinkResent,
  getSendAnotherRequest,
  getLinkState
}
